import React from 'react';
import { ArrowRight, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-900 pt-20 pb-10 border-t border-slate-800">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6 text-white font-bold text-2xl">
              <img src="/logo.png" alt="Businex Logo" className="w-14 h-14 md:w-16 md:h-16 object-contain rounded-xl shadow-md bg-white p-1" />
              Businex Technologies
            </div>
            <p className="text-slate-400 mb-6 leading-relaxed">
              Transforming ideas into digital reality through innovative software solutions.
            </p>
            <div className="flex flex-col gap-4 mt-6">
              <div className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors cursor-pointer group">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center group-hover:bg-blue-600 transition-colors">
                  <MapPin size={18} />
                </div>
                <span className="text-sm">123 Tech Avenue, Silicon Valley, CA 94025</span>
              </div>
              <div className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors cursor-pointer group">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center group-hover:bg-blue-600 transition-colors">
                  <Phone size={18} />
                </div>
                <span className="text-sm">+1 (555) 123-4567</span>
              </div>
              <div className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors cursor-pointer group">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center group-hover:bg-blue-600 transition-colors">
                  <Mail size={18} />
                </div>
                <span className="text-sm">hello@businex.com</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-slate-400 hover:text-blue-400 transition-colors">Web Development</Link></li>
              <li><Link to="/services" className="text-slate-400 hover:text-blue-400 transition-colors">Mobile Applications</Link></li>
              <li><Link to="/services" className="text-slate-400 hover:text-blue-400 transition-colors">Custom Software</Link></li>
              <li><Link to="/services" className="text-slate-400 hover:text-blue-400 transition-colors">UI/UX Design</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-slate-400 hover:text-blue-400 transition-colors">About Us</Link></li>
              <li><Link to="/portfolio" className="text-slate-400 hover:text-blue-400 transition-colors">Portfolio</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-blue-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6">Ready to work with us?</h4>
            <p className="text-slate-400 mb-4">Let's discuss your project and see how we can help.</p>
            <div className="flex bg-slate-800 rounded-full overflow-hidden p-1 border border-slate-700">
              <input type="email" placeholder="Your email address" className="bg-transparent flex-1 outline-none px-4 text-white text-sm" />
              <button className="bg-blue-600 hover:bg-blue-700 text-white w-10 h-10 flex items-center justify-center rounded-full transition-colors">
                <ArrowRight size={18} />
              </button>
            </div>
          </div>

        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Businex Technologies. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <span className="text-slate-500 hover:text-white transition-colors cursor-pointer">Privacy Policy</span>
            <span className="text-slate-500 hover:text-white transition-colors cursor-pointer">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
